import { render, staticRenderFns } from "./indexModelThree.vue?vue&type=template&id=366afc46&scoped=true&"
import script from "./indexModelThree.vue?vue&type=script&lang=js&"
export * from "./indexModelThree.vue?vue&type=script&lang=js&"
import style0 from "./indexModelThree.vue?vue&type=style&index=0&id=366afc46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366afc46",
  null
  
)

export default component.exports